import { useSideEffectOnMount } from "@web-monorepo/hooks";
import { ReactNode } from "react";
import { fetchHostState } from "src/pods/realtime";
import { dispatchToolkitReduxAction } from "src/state/toolkitReduxStore";

type HostStateContainerProps = {
  children: ReactNode;
};

export default function HostStateContainer({ children }: HostStateContainerProps) {
  useSideEffectOnMount(() => {
    dispatchToolkitReduxAction(fetchHostState());
  });

  return <>{children}</>;
}
